import EA from 'helpers/init';

export default EA.Methods.videoLazyLoad = ($this) => {
    const videoEl = $this;
    let observer;
    
    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                videoEl.play();
            } else {
                videoEl.pause();
            }
        });
    }

    function createObserver() {
        const options = {
            root: null,
            rootMargin: '100px',
            threshold: 0,
        };

        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(videoEl);
    }


    createObserver();
};
